import { makeAxiosRequest } from 'utils/apiMethods';

export default {
  updatePassword: makeAxiosRequest('/profile/update-password', { method: 'put' }),
  setEmailNotification: makeAxiosRequest('/profile/email-notification', { method: 'put' }, true),
  getAllBasins: makeAxiosRequest('/basins', { method: 'get' }, true),
  sendBasinForEmailNotification: makeAxiosRequest('/profile/basin-for-email-notification', { method: 'post' }, true),
  removeBasinForEmailNotification: makeAxiosRequest('/profile/basin-for-email-notification', { method: 'delete' }, true),
};
